module.exports = __webpack_public_path__ + "media/images/icon__link@3x-a09bdd75e0dcfbdb02b1201f83e6daaf.png";